import React, { ReactElement } from 'react';
import { List } from 'react-admin';
import { Box } from '@mui/material';
import { ShsTitle } from 'src/components/common';
import { ShsReturnButton } from '../common';
import { ToolbarActions } from './components/ToolbarActions';
import { EducationCenterType } from '../Employees/types';

interface EmployeesReportProps {
    onReturn: () => void;
    filters: ReactElement | ReactElement[];
    filterDefaultValues?: any;
}

export const EmployeesReport: React.FC<EmployeesReportProps> = ({ onReturn, filters, filterDefaultValues }) => {
    const buttonLabel = 'Назад до звітів';
    const singleCenterId = filterDefaultValues?.educationCenterId;

    return (
        <>
            <Box display="flex" justifyContent="flex-start" mb={2}>
                <ShsReturnButton onClick={onReturn} label={buttonLabel} />
            </Box>
            <ShsTitle title="Звіти по працівникам" />
            <List<EducationCenterType>
                resource="reports"
                exporter={false}
                empty={false}
                actions={<ToolbarActions pageUrl={'employees'} singleCenterId={singleCenterId} />}
                filters={filters}
                pagination={false}>
                <></>
            </List>
        </>
    );
};
